import React, { useEffect, useState } from 'react'
import searchIcon from '../assets/icons/searchIcon.svg'
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import PropertyCard from '../components/PropertyCard'

import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from "motion/react"
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useProperties from '../utils/useProperties';


const Home = () => {
    const [activeTab, setActiveTab] = useState("sale");

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const URLlocation = useLocation();

    const { properties } = useProperties()

    const [location, setLocation] = useState("");
    const [category, setCategory] = useState("");
    const [bedroom, setBedroom] = useState("");
    const [priceRange, setPriceRange] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        if (URLlocation.hash) {
            const id = URLlocation.hash.replace('#', '');
            const section = document.getElementById(id);
            if (section) {
                setTimeout(() => {
                    section.scrollIntoView({ behavior: 'smooth' });
                }, 0);
            }
        }
    }, [URLlocation]);

    const handleSearch = () => {
        const { min, max } = parsePriceRange(priceRange);
        const query = new URLSearchParams({
            location,
            category: activeTab,
            type: category,
            bedroom,
            minPrice: String(min),
            maxPrice: String(max),
        });

        navigate(`/properties/search?${query.toString()}`);
    };

    const parsePriceRange = (rangeStr: string) => {
        switch (rangeStr) {
            case "Below 2m": return { min: 0, max: 2000000 };
            case "2-5m": return { min: 2000000, max: 5000000 };
            case "5-10m": return { min: 5000000, max: 10000000 };
            case "10-above": return { min: 10000000, max: Infinity };
            case "50-100m": return { min: 50000000, max: 100000000 };
            case "100-200m": return { min: 100000000, max: 200000000 };
            case "200-500m": return { min: 200000000, max: 500000000 };
            case "500-above": return { min: 500000000, max: Infinity };
            default: return { min: 0, max: Infinity };
        }
    };

    return (
        <div className='bg-[#E6E8DC]'>
            <div className='relative'>
                <div className="z-10 absolute inset-0 bg-black bg-opacity-40"></div>
                <div className='h-screen min-h-[150vh] md:min-h-max'>
                    <Swiper
                        spaceBetween={30}
                        centeredSlides={true}
                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                        }}
                        loop={true}
                        effect={'fade'}
                        modules={[EffectFade, Autoplay]}
                        className="h-full mySwiper"
                    >
                        <SwiperSlide>
                            <img src={require('../assets/imgs/hero1.jpeg')} alt='hero section background' className='block w-full h-full object-cover' />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={require('../assets/imgs/hero2.jpeg')} alt='hero section background' className='block w-full h-full object-cover' />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={require('../assets/imgs/hero3.jpeg')} alt='hero section background' className='block w-full h-full object-cover' />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={require('../assets/imgs/hero4.jpeg')} alt='hero section background' className='block w-full h-full object-cover' />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={require('../assets/imgs/hero5.jpeg')} alt='hero section background' className='block w-full h-full object-cover' />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img src={require('../assets/imgs/hero6.jpeg')} alt='hero section background' className='block w-full h-full object-cover' />
                        </SwiperSlide>

                    </Swiper>
                </div>
                <div className='top-[150px] md:top-1/2 left-1/2 z-20 absolute flex md:flex-row flex-col items-center gap-[60px] w-[90%] overflow-hidden -translate-x-1/2 md:-translate-y-1/2 md:transform'>
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, translateX: -400 }}
                        animate={{ translateX: 0 }}
                        whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
                        transition={{ duration: 0.7, ease: "linear" }}
                        className='flex flex-col gap-5 m-auto px-7 md:w-1/2 text-white'>
                        <h1 className='font-[PlayfairDisplay] font-semibold text-[40px] md:text-[50px] md:text-left text-center'>Buy, Sell, and Rent Properties with Ease </h1>
                        <p className='font-[Roboto] font-medium text-[18px] md:text-left text-center'>Your trusted partner in seamless real estate solutions.
                            Explore premium listings, book shortlets schedule inspections, or speak with us for consultation today</p>

                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, translateY: 400 }}
                        animate={{ translateY: 0 }}
                        whileInView={{ opacity: 1, scale: 1, translateY: 0 }}
                        transition={{ duration: 0.7, ease: "easeOut" }}
                        className='md:w-[40%]'>
                        <div className="flex justify-center items-center md:min-h-screen" >
                            <div className="bg-white shadow-lg p-6 rounded-lg w-full max-w-md">
                                {/* Tabs */}
                                <div className="flex border-b">
                                    <button
                                        className={`w-1/2 py-2 text-center ${activeTab === "sale" ? "text-white bg-[#c08b53]" : "text-gray-800"} font-semibold rounded-t-lg`}
                                        onClick={() => setActiveTab("sale")}
                                    >
                                        FOR SALE
                                    </button>
                                    <button
                                        className={`w-1/2 py-2 text-center ${activeTab === "rent" ? "text-white bg-[#8f9537]" : "text-gray-800"} font-semibold rounded-t-lg`}
                                        onClick={() => setActiveTab("rent")}
                                    >
                                        FOR RENT
                                    </button>
                                </div>

                                {/* Search Form */}
                                <div className="space-y-4 mt-4">
                                    <div>
                                        <label className="text-gray-500 text-sm">Property Location</label>
                                        <input
                                            type="text"
                                            placeholder="Enter an area"
                                            value={location}
                                            onChange={(e) => setLocation(e.target.value)}
                                            className="mt-1 p-2 border border-gray-300 rounded w-full"
                                        />
                                    </div>

                                    <div>
                                        <label className="text-gray-500 text-sm">I'm interested in ...</label>
                                        <select value={category} onChange={(e) => setCategory(e.target.value)} className="mt-1 p-2 border border-gray-300 rounded w-full">
                                            <option value="">Property Categories</option>
                                            <option value="duplex">Duplex</option>
                                            <option value="terrace">Terrace</option>
                                            <option value="bungalow">Bungalow</option>
                                            <option value="apartment">Apartment</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="text-gray-500 text-sm">I'm looking for ...</label>
                                        <select value={bedroom} onChange={(e) => setBedroom(e.target.value)} className="mt-1 p-2 border border-gray-300 rounded w-full">
                                            <option value="">Bedroom</option>
                                            <option value="1">1 Bedroom</option>
                                            <option value="2">2 Bedrooms</option>
                                            <option value="3">3 Bedrooms</option>
                                            <option value="4">4 Bedrooms</option>
                                            <option value="5">5 Bedrooms</option>
                                            <option value="Mini flat">Mini flat</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="text-gray-500 text-sm">I'm interested to pay ...</label>
                                        <select value={priceRange} onChange={(e) => setPriceRange(e.target.value)} className="mt-1 p-2 border border-gray-300 rounded w-full">
                                            <option value="">Property Price</option>
                                            {activeTab === "sale" ? (
                                                <>
                                                    <option value="50-100m">₦50M - ₦100M</option>
                                                    <option value="100-200m">₦100M - ₦200M</option>
                                                    <option value="200-500m">₦200M - ₦500M</option>
                                                    <option value="500-above">₦500M and above</option>
                                                </>
                                            ) : (
                                                <>
                                                    <option value="Below 2m">Below ₦2M</option>
                                                    <option value="2-5m">₦2M - ₦5M</option>
                                                    <option value="5-10m">₦5M - ₦10M</option>
                                                    <option value="10-above">₦10M and above</option>
                                                </>
                                            )}
                                        </select>
                                    </div>

                                    <button
                                        className="flex justify-center items-center bg-black hover:bg-gray-800 mt-4 p-2 rounded w-full text-white"
                                        onClick={handleSearch}
                                    >
                                        <img src={searchIcon} className='h-[35px]' alt='search icon' /> SEARCH
                                    </button>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
            <div className="bg-gray-50 text-gray-800">
                {/* Services Section */}
                <section className="mx-auto px-4 py-12 max-w-7xl overflow-hidden">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, }}
                        whileInView={{ opacity: 1, scale: 1, }}
                        transition={{ duration: 0.7, ease: "easeOut" }}
                        className="mb-12 text-center">
                        <h2 className="font-semibold text-[#c08b53] text-sm uppercase">About us</h2>
                        <h1 className="mt-2 font-bold text-4xl">We Are Simply The Best</h1>
                        <p className="mx-auto mt-4 max-w-3xl text-gray-600">
                            At AK Jodem Limited, we specialize in delivering top-tier luxury homes in Lagos, Nigeria. With a commitment to excellence and a passion for real estate, we’ve built a reputation for quality, integrity, and client satisfaction. Whether you're buying, renting, or investing, we offer premium properties that combine comfort, class, and value. We don’t just sell houses — we deliver dream homes.
                        </p>
                    </motion.div>

                    <div className="gap-8 grid grid-cols-1 md:grid-cols-3">
                        {/* Real Estate Sales */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 0 }}
                            className="bg-white shadow-lg rounded-lg overflow-hidden"
                        >
                            <img
                                src={require('../assets/imgs/hero1.jpeg')}
                                alt="Real Estate Sales"
                                className="w-full h-48 object-cover"
                                loading="lazy"
                            />
                            <div className="p-6">
                                <h3 className="font-semibold text-lg">REAL ESTATE SALES</h3>
                                <ul className="space-y-1 mt-2 text-gray-600 list-disc list-inside">
                                    <li>Purchase of land and homes across Nigeria</li>
                                    <li>Verified properties with secure documentation</li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Rentals & Shortlets */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 0 }}
                            className="bg-white shadow-lg rounded-lg overflow-hidden"
                        >
                            <img
                                src={require('../assets/imgs/hero3.jpeg')}
                                alt="Rentals & Shortlets"
                                className="w-full h-48 object-cover"
                                loading="lazy"
                            />
                            <div className="p-6">
                                <h3 className="font-semibold text-lg">RENTALS & SHORTLETS</h3>
                                <ul className="space-y-1 mt-2 text-gray-600 list-disc list-inside">
                                    <li>Affordable and premium houses for rent</li>
                                    <li>Fully serviced shortlet apartments in prime locations</li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Construction & Development */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 0 }}
                            className="bg-white shadow-lg rounded-lg overflow-hidden"
                        >
                            <img
                                src={require('../assets/imgs/services1.jpg')}
                                alt="Construction & Development"
                                className="w-full h-48 object-cover"
                                loading="lazy"
                            />
                            <div className="p-6">
                                <h3 className="font-semibold text-lg">CONSTRUCTION & DEVELOPMENT</h3>
                                <ul className="space-y-1 mt-2 text-gray-600 list-disc list-inside">
                                    <li>Building residential and commercial properties</li>
                                    <li>Off-plan project development & supervision</li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Real Estate Consultancy */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 0 }}
                            className="bg-white shadow-lg rounded-lg overflow-hidden"
                        >
                            <img
                                src={require('../assets/imgs/services4.jpg')}
                                alt="Real Estate Consultancy"
                                className="w-full h-48 object-cover"
                                loading="lazy"
                            />
                            <div className="p-6">
                                <h3 className="font-semibold text-lg">REAL ESTATE CONSULTANCY</h3>
                                <ul className="space-y-1 mt-2 text-gray-600 list-disc list-inside">
                                    <li>Investment advice and market insights</li>
                                    <li>Personalized property search and guidance</li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Property Management */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 0 }}
                            className="bg-white shadow-lg rounded-lg overflow-hidden"
                        >
                            <img
                                src={require('../assets/imgs/propertybg.jpeg')}
                                alt="Property Management"
                                className="w-full h-48 object-cover"
                                loading="lazy"
                            />
                            <div className="p-6">
                                <h3 className="font-semibold text-lg">PROPERTY MANAGEMENT</h3>
                                <ul className="space-y-1 mt-2 text-gray-600 list-disc list-inside">
                                    <li>Tenant sourcing, rent collection & maintenance</li>
                                    <li>Peace of mind for property owners</li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Real Estate Marketing */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 0 }}
                            className="bg-white shadow-lg rounded-lg overflow-hidden"
                        >
                            <img
                                src={require('../assets/imgs/hero6.jpeg')}
                                alt="Real Estate Marketing"
                                className="w-full h-48 object-cover"
                                loading="lazy"
                            />
                            <div className="p-6">
                                <h3 className="font-semibold text-lg">REAL ESTATE MARKETING</h3>
                                <ul className="space-y-1 mt-2 text-gray-600 list-disc list-inside">
                                    <li>Strategic promotions for property owners & developers</li>
                                    <li>Digital and offline marketing services</li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Logistics */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 0 }}
                            className="bg-white shadow-lg rounded-lg overflow-hidden"
                        >
                            <img
                                src={require('../assets/imgs/log5.jpg')}
                                alt="Logistics"
                                className="w-full h-48 object-cover"
                                loading="lazy"
                            />
                            <div className="p-6">
                                <h3 className="font-semibold text-lg">LOGISTICS</h3>
                                <ul className="space-y-1 mt-2 text-gray-600 list-disc list-inside">
                                    <li>Reliable delivery services for businesses and individuals</li>
                                    <li>Freight and cargo services</li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Agriculture */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 0 }}
                            className="bg-white shadow-lg rounded-lg overflow-hidden"
                        >
                            <img
                                src={require('../assets/imgs/agric1.jpg')}
                                alt="Agriculture"
                                className="w-full h-48 object-cover"
                                loading="lazy"
                            />
                            <div className="p-6">
                                <h3 className="font-semibold text-lg">AGRICULTURE</h3>
                                <ul className="space-y-1 mt-2 text-gray-600 list-disc list-inside">
                                    <li>Farming and produce supply</li>
                                    <li>Agriculture investment opportunities</li>
                                </ul>
                            </div>
                        </motion.div>

                        {/* Oil and Gass */}
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: 0 }}
                            className="bg-white shadow-lg rounded-lg overflow-hidden"
                        >
                            <img
                                src={require('../assets/imgs/oil&gas.jpg')}
                                alt="Agriculture"
                                className="w-full h-48 object-cover object-top"
                                loading="lazy"
                            />
                            <div className="p-6">
                                <h3 className="font-semibold text-lg">OIL & GAS</h3>
                                <ul className="space-y-1 mt-2 text-gray-600 list-disc list-inside">
                                    <li>Delivered reliable petroleum products with competitive pricing.</li>
                                    <li>Maintained safety and compliance in operations.</li>
                                </ul>
                            </div>
                        </motion.div>
                    </div>


                </section>

                {/* About Us Section */}
                <section className="flex lg:flex-row flex-col items-center mx-auto px-4 py-12 max-w-7xl overflow-hidden">
                    {/* Text Section */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, }}
                        whileInView={{ opacity: 1, scale: 1, }}
                        transition={{ duration: 0.7, ease: "easeOut" }}
                        className="flex flex-col gap-4 mb-8 lg:mb-0 lg:pr-12 lg:w-1/2">
                        <h2 className="font-semibold text-[#c08b53] text-sm uppercase">Why Work With Us</h2>
                        <h1 className="mt-2 font-bold text-4xl">Your Trusted Real Estate Partner</h1>
                        <p className="text-gray-600 text-justify">
                            Our team of seasoned experts brings a wealth of experience and industry insight to every project—ensuring you receive the highest level of professionalism and service.</p>

                        <p className="text-gray-600 text-justify">We are committed to delivering luxury at the best value</p>

                        <p className="text-gray-600 text-justify">From the first consultation to the final delivery, we prioritize timely execution, budget-friendly solutions, and uncompromising quality.</p>

                        <p className="text-gray-600 text-justify">Ready to make your real estate dreams a reality?
                            Contact us today for more information and personalized support.</p>

                        <div className="mt-6">
                            <p className="font-semibold text-lg">John Akano Ademola</p>
                            <p className="text-[#c08b53] text-sm">CEO, Ak-Jodem</p>
                        </div>
                    </motion.div>

                    {/* Image Section */}
                    <motion.div

                        whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
                        transition={{ duration: 0.7, ease: "easeOut" }}
                        className="lg:w-1/2">
                        <img
                            src={require('../assets/imgs/CEO.JPG')}
                            alt="Your Trusted Real Estate Partner"
                            className="shadow-lg rounded-lg w-[400px] lg:w-full h-[280px] lg:h-[600px] object-cover object-top"
                            loading='lazy'
                        />
                    </motion.div>
                </section>
            </div>

            <section id="properties" className="bg-[#8f9537] py-12">
                <div className="bg-gray-100 mx-auto p-6 px-6 rounded-lg lg:w-1/2">
                    <h2 className="font-bold text-[#c08b53] text-3xl italic uppercase">CEO statement</h2>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, }}
                        whileInView={{ opacity: 1, scale: 1, }}
                        transition={{ duration: 0.7, ease: "easeOut" }}
                        className="">
                        <h3 className="mt-2 mb-2 font-[PlayfairDisplay] font-bold text-xl">THE REALTOR/DEVELOPER</h3>
                        <h1 className="mb-6 font-extrabold text-2xl [PlayfairDisplay]">AKANO JOHN</h1>
                        <p className='mt-4 font-[Roboto] text-[18px] text-justify'>John Akano is a visionary entrepreneur and the CEO of AK-JODEM Nigeria Ltd, a leading real estate firm committed to turning property aspirations into reality. With a passion for innovation and excellence, he has successfully led AK-JODEM into real estate sales, rentals, shortlets, and, most recently, construction and development. Under his leadership, the company has launched AK-JODEM COURT, an exclusive residential project in Sangotedo, Lagos.</p>
                        <p className='mt-4 font-[Roboto] text-[18px] text-justify'>Driven by integrity and a customer-first approach, John Akano is dedicated to providing premium housing solutions while creating wealth opportunities for investors and partners in Nigeria's booming real estate sector.</p>
                    </motion.div>
                </div>
            </section>

            <section id="properties" className="bg-gray-50 py-12">
                <div className="mx-auto px-6 max-w-7xl overflow-hidden">
                    <h2 className="font-semibold text-[#c08b53] text-sm uppercase">Exclusive</h2>
                    <h1 className="mt-2 mb-6 font-bold text-4xl">Featured Properties</h1>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, }}
                        whileInView={{ opacity: 1, scale: 1, }}
                        transition={{ duration: 0.7, ease: "easeOut" }}
                        className="gap-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                        {/* Property Card Example */}
                        {properties
                            ?.filter(item => item.featured === "Yes")
                            .map(item => (
                                <Link to={`/properties/${item.category}/${item.id}`}>
                                    <PropertyCard
                                        key={item.id}
                                        title={item.name}
                                        desc={item.description}
                                        price={item.price}
                                        imageUrl={`https://akjodem.com/${item.imgs?.[0]}`}
                                        bedrooms={item.bed}
                                        bathrooms={item.bath}
                                        area={item.sqft}
                                        sold={item.sold}
                                        featured={item.featured}
                                    />
                                </Link>
                            ))}
                    </motion.div>

                    <button className="bg-[#c08b53] hover:bg-orange-600 shadow-md mt-6 px-6 py-3 rounded-lg font-semibold text-white">
                        Load More
                    </button>
                </div>
            </section>

            <section id="areas" className="bg-black py-12 text-white">
                <div className="flex lg:flex-row flex-col items-center gap-10 mx-auto px-6 max-w-[90%] overflow-hidden">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, translateX: 200 }}
                        whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
                        transition={{ duration: 0.7, ease: "linear" }}
                        className='lg:w-[40%]'>
                        <h2 className="font-semibold text-[#c08b53] text-sm uppercase">Exclusive</h2>
                        <h1 className="mt-2 mb-6 font-[PlayfairDisplay] font-bold text-7xl">Popular Areas</h1>
                        <p className='mt-4 font-[Roboto] text-[18px]'>Dynamic approach, and tireless commitment to facilitating transactions for buyers and sellers.

                            In the vibrant neighborhood of Lekki, Victoria Island and Ikoyi, Ak-Jodem is renowned among residents, property developers, local businesses, and professionals in the.</p>
                    </motion.div>
                    <div className="gap-8 grid grid-cols-1 md:grid-cols-3 overflow-hidden">

                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, translateY: -300 }}
                            animate={{ translateY: 0 }}
                            whileInView={{ opacity: 1, scale: 1, translateY: 0 }}
                            transition={{ duration: 0.7, ease: "easeOut" }}
                            className="relative">
                            <img src={require('../assets/imgs/hero1.jpeg')} alt="https://source.unsplash.com/400x300/?suburb" className="rounded-tr-[90px] rounded-bl-[90px] w-full h-[600px] object-cover" loading='lazy' />
                            <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-25">
                                <h3 className="font-bold text-white text-2xl">OSAPA</h3>
                            </div>
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, translateY: 300 }}
                            animate={{ translateY: 0 }}
                            whileInView={{ opacity: 1, scale: 1, translateY: 0 }}
                            transition={{ duration: 0.7, ease: "easeOut" }}
                            className="relative">
                            <img src={require('../assets/imgs/hero2.jpeg')} alt="https://source.unsplash.com/400x300/?suburb" className="rounded-tr-[90px] rounded-bl-[90px] w-full h-[600px] object-cover" loading='lazy' />
                            <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-25">
                                <h3 className="font-bold text-white text-2xl">AJAH</h3>
                            </div>
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, translateX: -300 }}
                            animate={{ translateX: 0 }}
                            whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
                            transition={{ duration: 0.7, ease: "easeOut" }}
                            className="relative">
                            <img src={require('../assets/imgs/hero3.jpeg')} alt="https://source.unsplash.com/400x300/?suburb" className="rounded-tr-[90px] rounded-bl-[90px] w-full h-[600px] object-cover" loading='lazy' />
                            <div className="absolute inset-0 flex justify-center items-center bg-black bg-opacity-25">
                                <h3 className="font-bold text-white text-2xl">LEKKI</h3>
                            </div>
                        </motion.div>
                        {/* Add more <AreaCard /> components */}
                    </div>
                </div>
            </section>



            <section className="bg-white py-12" id="testimonial">
                <div className="mx-auto px-6 max-w-7xl overflow-hidden">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, translateX: 400 }}
                        whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
                        transition={{ duration: 0.7, ease: "linear" }}
                        className="mb-12 text-center">
                        <h2 className="font-semibold text-[#c08b53] text-sm uppercase">Testimonial</h2>
                        <h1 className="mt-2 font-bold text-4xl">What are clients say</h1>
                    </motion.div>
                    <Slider {...settings}>
                        <div className='lg:!flex items-center gap-[10px] bg-[#c08b53] p-[20px] rounded-[14px]'>
                            <div className='text-white'>
                                <p className='relative p-[20px]'>
                                    <span className='top-[10px] left-0 absolute font-bold text-[32px] text-[black]'>“</span>
                                    By far, all my dealings with AK Jodem have been successful."
                                    Everything has gone smoothly—no stress, no surprises.

                                    Whenever I call on him for a property, he always shows up and ensures the property is free from any encumbrance.
                                    He does his due diligence, and that gives me peace of mind every single time.

                                    Doing business with AK Jodem is superb.
                                    You honestly have nothing to worry about.
                                    <sub className='font-bold text-[32px] text-[black]'>“</sub>
                                </p>
                                <div className='px-[20px]'>
                                    <h3 className='font-medium text-[20px]'>Mr Peter Odigie</h3>
                                </div>
                            </div>

                        </div>
                        <div className='lg:!flex items-center gap-[10px] bg-[#c08b53] p-[20px] rounded-[14px]'>
                            <div className='text-white'>
                                <p className='relative p-[20px]'>
                                    <span className='top-[10px] left-0 absolute font-bold text-[32px] text-[black]'>“</span>
                                    Mr. John is the right person for you.”
                                    Some people sell you a house and disappear—but not AK Jodem.

                                    He remembers his clients, checks in after the sale, and genuinely cares about how you're settling in.
                                    No issues. No stress. Just real support, even after the keys have been handed over.

                                    I guarantee you with my full chest—buy from AK Jodem, and you’ll have peace of mind.
                                    He’s good like that.
                                    <sub className='font-bold text-[32px] text-[black]'>“</sub>
                                </p>
                                <div className='px-[20px]'>
                                    <h3 className='font-medium text-[20px]'>Mrs Helen Onyibe</h3>
                                </div>
                            </div>

                        </div>
                        <div className='lg:!flex items-center gap-[10px] bg-[#c08b53] p-[20px] rounded-[14px]'>
                            <div className='text-white'>
                                <p className='relative p-[20px]'>
                                    <span className='top-[10px] left-0 absolute font-bold text-[32px] text-[black]'>“</span>
                                    Working with AK-JODEM was a game-changer for us. Their real estate team helped us secure and develop a property that perfectly matched our vision. From consultation to delivery, they demonstrated professionalism, transparency, and genuine care for our needs.
                                    <sub className='font-bold text-[32px] text-[black]'>“</sub>
                                </p>
                                <div className='px-[20px]'>
                                    <h3 className='font-medium text-[20px]'>Mrs. Adesuwa A.</h3>
                                </div>
                            </div>

                        </div>
                        <div className='lg:!flex items-center gap-[10px] bg-[#c08b53] p-[20px] rounded-[14px]'>
                            <div className='text-white'>
                                <p className='relative p-[20px]'>
                                    <span className='top-[10px] left-0 absolute font-bold text-[32px] text-[black]'>“</span>
                                    I joined AK-JODEM’s farmland investment plan and was impressed by the level of structure, transparency, and return on investment. Their team handled every stage of the process — from land clearing to harvesting — with remarkable efficiency.
                                    <sub className='font-bold text-[32px] text-[black]'>“</sub>
                                </p>
                                <div className='px-[20px]'>
                                    <h3 className='font-medium text-[20px]'>Tunde O.</h3>
                                </div>
                            </div>

                        </div>
                        <div className='lg:!flex items-center gap-[10px] bg-[#c08b53] p-[20px] rounded-[14px]'>
                            <div className='text-white'>
                                <p className='relative p-[20px]'>
                                    <span className='top-[10px] left-0 absolute font-bold text-[32px] text-[black]'>“</span>
                                    We’ve relied on AK-JODEM for our logistics and fuel supply needs for over a year. Their diesel delivery has been timely and competitively priced, and their fleet services have improved our operations significantly. Truly a reliable partner!
                                    <sub className='font-bold text-[32px] text-[black]'>“</sub>
                                </p>
                                <div className='px-[20px]'>
                                    <h3 className='font-medium text-[20px]'>Engr. Chidi N.</h3>
                                </div>
                            </div>

                        </div>
                    </Slider>

                </div>
            </section>



            {/* <section className="bg-white py-12">
                <div className="mx-auto px-6 max-w-7xl overflow-hidden">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, }}
                        whileInView={{ opacity: 1, scale: 1, }}
                        transition={{ duration: 0.7, ease: "linear" }}
                        className="mb-12 text-center">
                        <h2 className="font-semibold text-[#c08b53] text-sm uppercase">GALLERY</h2>
                        <p className="mx-auto mt-4 max-w-3xl text-gray-600">
                            Comfort home for happy living
                        </p>
                    </motion.div>

                    <div className="gap-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0 }} className="block col-span-1 row-span-2 w-full h-[520px] overflow-hidden">
                            <img src={require('../assets/imgs/hero1.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0.2 }} className="block col-span-1 row-span-1 w-full h-[260px] overflow-hidden">
                            <img src={require('../assets/imgs/hero2.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0.4 }} className="block col-span-1 row-span-2 w-full h-[520px] overflow-hidden">
                            <img src={require('../assets/imgs/hero3.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0.6 }} className="block col-span-1 row-span-2 w-full h-[520px] overflow-hidden">
                            <img src={require('../assets/imgs/hero4.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0.8 }} className="block col-span-1 row-span-1 w-full h-[260px] overflow-hidden">
                            <img src={require('../assets/imgs/hero5.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 1.0 }} className="block col-span-1 row-span-1 w-full h-[260px] overflow-hidden">
                            <img src={require('../assets/imgs/hero6.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0.2 }} className="block col-span-1 row-span-2 w-full h-[520px] overflow-hidden">
                            <img src={require('../assets/imgs/feat1.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0.4 }} className="block col-span-1 row-span-1 w-full h-[260px] overflow-hidden">
                            <img src={require('../assets/imgs/feat2.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0.6 }} className="block col-span-1 row-span-2 w-full h-[520px] overflow-hidden">
                            <img src={require('../assets/imgs/feat3.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0.8 }} className="block col-span-1 row-span-1 w-full h-[260px] overflow-hidden">
                            <img src={require('../assets/imgs/feat4.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 1.0 }} className="block col-span-1 row-span-1 w-full h-[260px] overflow-hidden">
                            <img src={require('../assets/imgs/feat5.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0.2 }} className="block col-span-1 row-span-2 w-full h-[520px] overflow-hidden">
                            <img src={require('../assets/imgs/services1.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0.4 }} className="block col-span-1 row-span-1 w-full h-[260px] overflow-hidden">
                            <img src={require('../assets/imgs/services2.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, }}
                            whileInView={{ opacity: 1, scale: 1, }}
                            transition={{ duration: 0.7, ease: "linear", delay: 0.6 }} className="block col-span-1 row-span-2 w-full h-[520px] overflow-hidden">
                            <img src={require('../assets/imgs/services3.jpeg')} alt='hero section background' className='w-full h-full object-cover scale-110 hover:scale-100 transition-transform duration-300 transform' loading='lazy' />
                        </motion.div>

                    </div>
                </div>
            </section> */}


            <section id="contact" className="bg-black py-[100px] text-white">
                <div className="flex lg:flex-row flex-col lg:justify-between items-center mx-auto px-6 max-w-7xl overflow-hidden">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8, translateX: -200 }}
                        whileInView={{ opacity: 1, scale: 1, translateX: 0 }}
                        transition={{ duration: 0.7, ease: "linear" }}>
                        <h2 className="font-bold text-3xl">Are You Looking To Buy A Home?</h2>
                        <p className="mt-4 text-lg">
                            Explore Akjodem’s finest neighborhoods and let us guide you through the buying process.
                        </p>
                    </motion.div>
                    <Link to="contact"><button className="bg-white hover:bg-[#c08b53] shadow-md mt-6 lg:mt-0 px-6 py-3 rounded-lg font-semibold text-[#c08b53] hover:text-white">
                        Contact Us Today
                    </button>
                    </Link>
                </div>
            </section>

        </div>
    )
}

export default Home
